import React from "react";
function Enviroments() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_layout">
              <h1>Environments</h1>
              <hr />
              <p class="mt-30">
                We have both Testing and Production Environment for seamless
                integration. Initially, merchants will be using Test
                credentials, and after successful testing, we will provide them
                with LIVE credentials for the Production environment.
              </p>

              <p>
                We have a Simulator flow in the Test environment designed to
                test Success/Failure cases to ease merchants completing the
                integration.
              </p>
              {/* <p>The available payment modes include:</p> */}
              {/* <ul>
                <li>
                  <b>Debit Card:</b> allows customers to pay using their debit
                  card issued by any bank in India.{" "}
                </li>
                <li>
                  <b>Credit Card:</b> allows customers to pay using their credit
                  card issued by any bank in India or internationally.{" "}
                </li>
                <li>
                  <b>Net Banking:</b> allows customers to pay using their bank's
                  internet banking facility.
                </li>
                <li>
                  <b>UPI: </b>allows customers to pay using their UPI-enabled
                  bank account, making transactions quick and easy.
                </li>
                <li>
                  <b>Pay Later:</b> allows customers to defer payment for their
                  purchase and pay later through various financing options.
                </li>
                <li>
                  <b>Wallet:</b> allows customers to pay using digital wallets
                  like Paytm, Mobikwik, Freecharge, etc. Some wallets may
                  require approval from Safexpay before they can be enabled.
                  Simply contact our Support Team to request approval.
                </li>
              </ul> */}

              <p>❖ Our Test and Production environments are separate.</p>

              <section id="idocs_content" class="mt-20 mb-20">
                <h2>Safexpay Test Environments</h2>
                <hr />
              </section>

              {/* <u > 
              <h4>Safexpay Test Environments</h4>
            </u> */}
            </section>
            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href="  https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </a> */}
                    <p>
                      {" "}
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <section id="idocs_content" class="mt-20 mb-20">
              <h2>Safexpay Production Environments</h2>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {" "}
                    {/* <a href="  https://pg.safexpay.ae/agcore/paymentProcessing">
                    https://pg.safexpay.ae/agcore/paymentProcessing
                    </a> */}
                    <p> https://pg.safexpay.ae/agcore/paymentProcessing</p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default Enviroments;
